import axios from "axios";
import { useEffect, useState } from "react";
import Dots from "react-activity/dist/Dots";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import "./Form.scss";

function Form() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://tell-me-more-backend-nyfc.onrender.com/form/${slug}`
        );
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error.response);
      }
    };
    fetchData();
  }, [slug]);

  const handleSubmit = async () => {
    const answersArray = [];
    for (let i = 0; i < answers.length; i++) {
      answersArray.push({
        questionId: data.questionsArray[i],
        answer: answers[i],
      });
    }
    try {
      const response = await axios.post(
        "https://tell-me-more-backend-nyfc.onrender.com/answer/create",
        { formId: data._id, answersArray: answersArray }
      );
      alert("Réponses enregistrées");
      setPage(page + 1);
      console.log(response.data);
    } catch (error) {
      console.log(error.response);
    }
  };

  ///function to check if email is valid
  const validateEmail = (mail) => {
    let expression = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g; //eslint-disable-line
    return expression.test(mail);
  };
  /////////////////////:::

  return isLoading ? (
    <Dots />
  ) : (
    <div>
      {
        //home page of a form (page 0)
        page === 0 ? (
          <div
            className="formStartPageContainer"
            style={{ backgroundColor: data.color }}
          >
            <div className="sondage">SONDAGE</div>
            <div className="title">{data.title}</div>
            <div className="questions">
              {data.questionsArray.length} question
              {data.questionsArray.length !== 1 ? "s" : null}
            </div>
            <div className="buttonContainer">
              <Button
                text={"Commencer"}
                color={"green"}
                func={() => {
                  setPage(page + 1);
                }}
                show={true}
              />
            </div>
          </div>
        ) : page === data.questionsArray.length + 1 ? (
          // last page after validation
          <div className="validationContainer">
            <h2>Vos réponses ont bien été enregistrées !</h2>
            <div className="buttonsDiv">
              <Button
                text={"Recommencer"}
                color={"green"}
                func={() => {
                  setPage(0);
                  setAnswers([]);
                  navigate(`/form/${data.slug}`);
                }}
                show={true}
              />
              <Button
                text={"Retourner à l'accueil"}
                color={"green"}
                func={() => {
                  setPage(0);
                  setAnswers([]);
                  navigate(`/`);
                }}
                show={true}
              />
            </div>
          </div>
        ) : (
          // pages from 1 to questionArray.length (one page by question)
          <div className="formPagesContainer">
            <div>
              QUESTION {page} / {data.questionsArray.length}
            </div>
            <h1>{data.questionsArray[page - 1].question}</h1>

            {
              //category 1 = text answer
              data.questionsArray[page - 1].category === 1 && (
                <textarea
                  onChange={(e) => {
                    const newAnswers = [...answers];
                    const value = e.target.value;
                    newAnswers[page - 1] = value;
                    setAnswers(newAnswers);
                  }}
                  placeholder="Votre réponse"
                ></textarea>
              )
            }
            {
              //category 2 = note 1-5 answer
              data.questionsArray[page - 1].category === 2 && (
                <div className="notes">
                  <div
                    className={
                      answers[page - 1] === 1
                        ? "note greenNote"
                        : "note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = 1;
                      setAnswers(newAnswers);
                    }}
                  >
                    1
                  </div>
                  <div
                    className={
                      answers[page - 1] === 2
                        ? "note greenNote"
                        : "note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = 2;
                      setAnswers(newAnswers);
                    }}
                  >
                    2
                  </div>
                  <div
                    className={
                      answers[page - 1] === 3
                        ? "note greenNote"
                        : "note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = 3;
                      setAnswers(newAnswers);
                    }}
                  >
                    3
                  </div>
                  <div
                    className={
                      answers[page - 1] === 4
                        ? "note greenNote"
                        : "note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = 4;
                      setAnswers(newAnswers);
                    }}
                  >
                    4
                  </div>
                  <div
                    className={
                      answers[page - 1] === 5
                        ? "note greenNote"
                        : "note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = 5;
                      setAnswers(newAnswers);
                    }}
                  >
                    5
                  </div>
                </div>
              )
            }
            {
              //category 3 = email answer
              data.questionsArray[page - 1].category === 3 && (
                <input
                  onChange={(e) => {
                    const newAnswers = [...answers];
                    const value = e.target.value;
                    newAnswers[page - 1] = value;
                    setAnswers(newAnswers);
                  }}
                  placeholder="Votre email"
                ></input>
              )
            }
            {
              //category 4 = yes/no answer
              data.questionsArray[page - 1].category === 4 && (
                <div className="buttonsDiv">
                  <div
                    className={
                      answers[page - 1] === true
                        ? "round greenNote"
                        : "round note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = true;
                      setAnswers(newAnswers);
                    }}
                  >
                    OUI
                  </div>
                  <div
                    className={
                      answers[page - 1] === false
                        ? "round greenNote"
                        : "round note greyNote"
                    }
                    onClick={() => {
                      const newAnswers = [...answers];
                      newAnswers[page - 1] = false;
                      setAnswers(newAnswers);
                    }}
                  >
                    NON
                  </div>
                </div>
              )
            }

            <div className="bottomButtons">
              {/* navigation between pages - "previous" button is displayed on every page */}
              <Button
                text={"Précédent"}
                color={"green"}
                func={() => {
                  setPage(page - 1);
                }}
                show={true}
              />

              {
                // "next" button is displayed except on last page
                page < data.questionsArray.length && (
                  <Button
                    text={"Suivant"}
                    color={"green"}
                    func={() => {
                      if (
                        data.questionsArray[page - 1].category === 3 &&
                        validateEmail(answers[page - 1]) === false
                      ) {
                        alert("Invalid email");
                      } else {
                        setPage(page + 1);
                        const newAnswers = [...answers];
                        if (newAnswers[page - 1] === undefined) {
                          newAnswers[page - 1] = "Pas de réponse";
                          setAnswers(newAnswers);
                        }
                      }
                    }}
                    show={true}
                  />
                )
              }

              {
                // "submit" button is displayed only on last page
                page === data.questionsArray.length && (
                  <Button
                    text={"Valider mes réponses"}
                    color={"green"}
                    func={handleSubmit}
                    show={true}
                  />
                )
              }
            </div>
          </div>
        )
      }
    </div>
  );
}

export default Form;
